import DashboardIcon from "components/icons/DashboardIcon";
import ItemIcon from "components/icons/ItemIcon";
import FileIcon from "components/icons/FileIcon";
import ClientsIcon from "components/icons/ClientsIcon";
import WorkerIcon from "components/icons/WorkerIcon";
import ConfigurationIcon from "components/icons/ConfigurationIcon";
import MapIcon from "components/icons/Map";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import s from "./styles";
import {
  CONFIG_SUBMENU,
  INFO_SUBMENU,
  INVENTORY_SUBMENU,
  WORKERS_SUBMENU,
} from "../index";
import MainMenuItem from "./MainMenuItem";

function MainMenu({ setSubMenu }) {
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;
  return (
    <s.Wrapper>
      <MainMenuItem
        selected={path.includes("/dashboard")}
        Icon={DashboardIcon}
        text={t("containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.dashboard")}
        path="/dashboard"
      />
      <MainMenuItem
        selected={path.includes("/inventory")}
        Icon={ItemIcon}
        text={t("containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.inventory")}
        onClick={() => setSubMenu(INVENTORY_SUBMENU)}
      />
      <MainMenuItem
        selected={path.includes("/inform")}
        Icon={FileIcon}
        text={t("containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.inform")}
        onClick={() => setSubMenu(INFO_SUBMENU)}
      />
      <MainMenuItem
        selected={path.includes("/customer/list")}
        Icon={ClientsIcon}
        text={t("containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.clients")}
        path="/customer/list"
      />
      <MainMenuItem
        selected={path.includes("/employees/list")}
        Icon={WorkerIcon}
        text={t("containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.workers")}
        onClick={() => setSubMenu(WORKERS_SUBMENU)}
      />
      <MainMenuItem
        selected={path.includes("/rooms")}
        Icon={MapIcon}
        text={t("containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.rooms")}
        path="/rooms"
      />

      <MainMenuItem
        selected={path.includes("/settings/")}
        Icon={ConfigurationIcon}
        text={t(
          "containers.SideBarTopMenuHOC.BottomDrawer.MainMenu.configuration"
        )}
        onClick={() => setSubMenu(CONFIG_SUBMENU)}
      />
    </s.Wrapper>
  );
}

export default MainMenu;
